module.exports = __webpack_public_path__ + "img/kaenguru-chroniken.51e41027.jpg";